import type { ProjectSummary, SiteSummary } from '@/entities/layout';
import { createIdentifiableSlug } from '@/shared/lib/utils/slug-utils';

/**
 * Swaps the project and site slugs of the current URL, keeping the page the user
 * is on and its query string. Routes are `/:projectId/:siteId/<rest>`, so anything
 * from the third segment on survives the switch.
 */
export const buildProjectSitePath = (
  project: ProjectSummary,
  site: SiteSummary,
  { pathname, search }: { pathname: string; search: string }
) => {
  const restPath = pathname.split('/').slice(3).join('/');
  const projectSlug = createIdentifiableSlug(project.name, project.id);
  const siteSlug = createIdentifiableSlug(site.name, site.id);

  return `/${projectSlug}/${siteSlug}/${restPath}${search}`;
};
